export default __webpack_public_path__ + "assets/models/35a21fe6571fe3dc70b6b0c6c83c5295.glb";